import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@mui/material/Grid";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CircleIcon from "@mui/icons-material/Circle";
import find from "lodash/find";
import { findIndex, intersectionBy } from "lodash";

import SelectionList from "../../Components/List/SelectionList";
import { taskSliceActions } from "../../Store/Slices/TaskSlice";
import { convertMinToSecond } from "../../Js/TimeAndDate";

const AssetSelect = (props) => {
  const navigation = useNavigate();
  const classes = useStyles();
  const { moduleId, sessionId, nodeId, id } = useParams();
  const dispatch = useDispatch();

  // State
  const [assets, setAssets] = useState(null);
  const [titleText, setTitleText] = useState("");
  const [subTitleText, setSubTitleText] = useState("");
  const [selectedAll, setSelectedAll] = useState(false);

  // Redux state
  const product = useSelector((state) => state.product.productData);
  const language = useSelector((state) => state.product.language);
  const selectedAssets = useSelector((state) => state.task.selectedAssets);

  useEffect(() => {
    let module;
    if (language > -1) {
      module = find(
        JSON.parse(product[0]["course_data"])["data"][0]["data"][language][
          "data"
        ],
        { id: moduleId }
      );
    } else {
      module = find(JSON.parse(product[0]["course_data"])["data"][0]["data"], {
        id: moduleId,
      });
    }
    let session = find(module.data, { id: sessionId });
    let node = find(session.data, { id: nodeId });
    setTitleText(node.value);
    let leaf = find(node.data, { id: id });
    setSubTitleText(leaf.value);
    setAssets(leaf.data);
  }, [moduleId, sessionId, nodeId, id, product]);

  useEffect(() => {
    checkSelectAll();
  }, [selectedAssets, assets]);

  let checkSelectAll = () => {
    let interSect = intersectionBy(assets, selectedAssets, "id");
    if (interSect && assets && interSect.length == assets.length) {
      setSelectedAll(true);
    } else {
      setSelectedAll(false);
    }
  };

  // Add & Remove assets from selection
  const addInAssets = (value, assetName, duration, status) => {
    if (status) {
      dispatch(
        taskSliceActions.addAsset({
          id: value,
          name: assetName,
          duration: convertMinToSecond(duration),
        })
      );
    } else {
      dispatch(taskSliceActions.removeAsset(value));
    }
  };

  const selectAllClick = () => {
    assets.forEach((val) => {
      if (!selectedAll) {
        if (findIndex(selectedAssets, { id: val.id }) == -1) {
          dispatch(
            taskSliceActions.addAsset({
              id: val.id,
              name: val.value,
              duration: convertMinToSecond(val.duration),
            })
          );
        }
      } else {
        dispatch(taskSliceActions.removeAsset(val.id));
      }
    });
    setSelectedAll(!selectedAll);
  };

  const goToView = (id) => {
    navigation(`/Task/AssetView/${id}`);
  };

  return (
    <Grid container>
      <Grid item xs={12} sx={{ pl: 3, pr: 7 }}>
        <Box>
          <Typography
            color="primary.main"
            sx={{
              pl: 3,
              py: 2,
              fontWeight: 800,
              fontSize: "1.2rem",
              "@media (min-width: 1636px)": {
                fontSize: "1.6rem",
              },
            }}
          >
            {titleText}
          </Typography>
          <Typography
            color="primary.main"
            sx={{
              pl: 3,
              fontWeight: 600,
              fontSize: "0.9rem",
              "@media (min-width: 1636px)": {
                fontSize: "1.4rem",
              },
            }}
          >
            {subTitleText}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            sx={{
              my: 2,
              ml: 2,
              borderRadius: 15,
              backgroundColor: "#F5F5F5",
              color: "primary.main",
              height: "2rem",
              textTransform: "inherit",
              "@media (min-width: 1636px)": {
                fontSize: "1.4rem",
                height: "3rem",
              },
            }}
            onClick={selectAllClick}
          >
            <CircleIcon
              fontSize="small"
              value="a"
              name="radio-buttons"
              sx={{
                color: selectedAll ? "#DB8829" : "#D9D9D9",
                marginRight: 1,
              }}
            />
            Pick All
          </Button>
          <Box>
            <Grid
               
              sx={{ height: "58vh", overflow: "auto" }}
            >
              {assets &&
                assets.map((obj, index) => {
                  return (
                    <div key={`${index}_assets`}>
                      <SelectionList
                        title={`${index + 1}. ${obj.value}`}
                        value={obj.id}
                        actions={true}
                        from="TaskCreate"
                        checkTick={(val, assetName, status) => {
                          addInAssets(val, assetName, obj.duration, status);
                        }}
                        viewaction={true}
                        view={() => {
                          goToView(obj.id);
                        }}
                      />
                    </div>
                  );
                })}
            </Grid>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default AssetSelect;
